import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialIssuesStatusesState = {};

const issuesStatusesSlice = createSlice({
  name: "issuesStatuses",
  initialState: initialIssuesStatusesState,
  reducers: {
    setIssuesStatusesData: (_state: any, action: PayloadAction<any>) =>
      action.payload.reduce((prev: Record<string, any>, curr: any) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setIssuesStatusesData } = issuesStatusesSlice.actions;

export const issuesStatuses = issuesStatusesSlice.reducer;

export default issuesStatusesSlice.reducer;
